import { apiFetch, toQuery } from "./legacy-integration-service";

//#region Type definitions

export type SearchSupplierOptions = {
    fieldCompanyId: number;
    name?: string | undefined | null;
};

export type SearchSupplierItemResponse = {
    id: number;
    name: string;
};

export type SearchSupplierResponse = SearchSupplierItemResponse[];

export type GetSupplierByIdResponse = {
    id: number;
    name: string;
};

//#endregion

export async function searchSuppliers(options: SearchSupplierOptions): Promise<SearchSupplierResponse> {
    return await apiFetch<SearchSupplierResponse>(`/suppliers/search?${toQuery(options)}`, {
        headers: { "Content-Type": "application/json" },
    });
}

export async function getSupplierById(id: number): Promise<GetSupplierByIdResponse> {
    return await apiFetch<GetSupplierByIdResponse>(`/suppliers/${id}`, {
        headers: { "Content-Type": "application/json" },
    });
}
